<template>
  <div class="data-analysis">
    <div class="page-header">
      <h2>数据分析</h2>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange">
      </el-date-picker>
    </div>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="data-item">
            <div class="data-icon">
              <i class="el-icon-s-data"></i>
            </div>
            <div class="data-info">
              <div class="data-title">总销售额</div>
              <div class="data-value">¥123,456</div>
              <div class="data-trend up">
                <i class="el-icon-top"></i>
                <span>12.5%</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="data-item">
            <div class="data-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="data-info">
              <div class="data-title">订单数量</div>
              <div class="data-value">1,234</div>
              <div class="data-trend up">
                <i class="el-icon-top"></i>
                <span>8.3%</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="data-item">
            <div class="data-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="data-info">
              <div class="data-title">新增客户</div>
              <div class="data-value">256</div>
              <div class="data-trend down">
                <i class="el-icon-bottom"></i>
                <span>3.2%</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="data-item">
            <div class="data-icon">
              <i class="el-icon-s-marketing"></i>
            </div>
            <div class="data-info">
              <div class="data-title">转化率</div>
              <div class="data-value">23.5%</div>
              <div class="data-trend up">
                <i class="el-icon-top"></i>
                <span>5.1%</span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>销售趋势</span>
              <el-radio-group v-model="salesChartType" size="small">
                <el-radio-button label="week">周</el-radio-button>
                <el-radio-button label="month">月</el-radio-button>
                <el-radio-button label="year">年</el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <div class="chart-container">
            <div class="chart-placeholder">销售趋势图表</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>客户分布</span>
            </div>
          </template>
          <div class="chart-container">
            <div class="chart-placeholder">客户分布图表</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>热销商品</span>
            </div>
          </template>
          <el-table :data="hotProducts" style="width: 100%">
            <el-table-column prop="name" label="商品名称"></el-table-column>
            <el-table-column prop="sales" label="销量"></el-table-column>
            <el-table-column prop="amount" label="销售额"></el-table-column>
            <el-table-column prop="trend" label="趋势">
              <template #default="scope">
                <div :class="['trend', scope.row.trend > 0 ? 'up' : 'down']">
                  <i :class="scope.row.trend > 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                  <span>{{ Math.abs(scope.row.trend) }}%</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <template #header>
            <div class="card-header">
              <span>客户活跃度</span>
            </div>
          </template>
          <div class="chart-container">
            <div class="chart-placeholder">客户活跃度图表</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'DataAnalysis',
  data() {
    return {
      dateRange: [],
      salesChartType: 'month',
      hotProducts: [
        {
          name: '商品A',
          sales: 1234,
          amount: '¥12,340',
          trend: 12.5
        },
        {
          name: '商品B',
          sales: 890,
          amount: '¥8,900',
          trend: -3.2
        },
        {
          name: '商品C',
          sales: 567,
          amount: '¥5,670',
          trend: 8.7
        }
      ]
    }
  },
  methods: {
    handleDateChange(val) {
      console.log('日期范围变化：', val)
      // 更新数据
    }
  }
}
</script>

<style scoped>
.data-analysis {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.data-item {
  display: flex;
  align-items: center;
}

.data-icon {
  font-size: 48px;
  margin-right: 20px;
  color: #409EFF;
}

.data-info {
  flex: 1;
}

.data-title {
  font-size: 14px;
  color: #909399;
}

.data-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin: 5px 0;
}

.data-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
}

.data-trend.up {
  color: #67C23A;
}

.data-trend.down {
  color: #F56C6C;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chart-container {
  height: 300px;
}

.chart-placeholder {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
  color: #909399;
}

.trend {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.trend.up {
  color: #67C23A;
}

.trend.down {
  color: #F56C6C;
}
</style> 